import draggable from 'vuedraggable';

Vue.component('manage-questions', {
    components: {
        draggable
    },

    props: ['id'],

    data () {
        return {
            questions: [],

            loading: false,

            modalLoading: false,

            activeId: null,

            editForm: $.extend(true, new Form({
                data: {
                    name: '',
                    type: '',
                    required: '',
                    options: []
                }
            }), {}),

            newOption: ''
        };
    },

    mounted () {
        this.getQuestions();

        $('#edit-question #delete-question').on('hidden.bs.modal', () => {
            this.activeId = null;
        });
    },

    methods: {
        getQuestions() {
            this.loading = true;

            axios.get('/api/questions/load_questions/' + this.id).then((response) => {
                this.loading = false;
                this.questions = response.data;
            });
        },

        editQuestion (id) {
            this.activeId = id;
            this.modalLoading = true;

            $('#edit-question').modal('show');

            axios.get('/api/questions/load_question/' + id).then((response) => {
                this.modalLoading = false;

                this.editForm.data.question = response.data.question;
                this.editForm.data.type = response.data.type;
                this.editForm.data.required = response.data.required;
                this.editForm.data.options = response.data.options;
            });
        },

        updateQuestion () {
            Http.post('/api/questions/update_question/' + this.activeId, this.editForm).then((response) => {
                this.editForm.resetForm();

                this.getQuestions();

                $('#edit-question').modal('hide');
            });
        },

        deleteQuestion (id) {
            this.activeId = id;

            $('#delete-question').modal('show');
        },

        doDeleteQuestion () {
            axios.post('/api/questions/delete_question/' + this.activeId).then(() => {
                this.getQuestions();

                $('#delete-question').modal('hide');
            });
        },

        addOption (e) {
            e.preventDefault();

            this.editForm.data.options.push(this.newOption);

            this.newOption = '';
        },

        deleteOption(index) {
            this.editForm.data.options.splice(index, 1);
        }
    },

    watch: {
        questions () {
            axios.post('/api/questions/question_order', this.questions);
        }
    }

});